export default __webpack_public_path__ + "static/media/beleza.1269d85f.webp";